/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/books/', params);
}

function exportData(params) {
  return api.get('/books/export', params);
}

function getType(params) {
  return api.get('/books/types', params);
}

function get(id, params) {
  return api.get(`/books/${id}`, params);
}

function create(params) {
  return api.post('/books', params);
}

function update(id, params) {
  return api.put(`/books/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/books/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function importBooks(params) {
  return api.post('/books/import', params);
}

function syncBooks(params) {
  return api.post('/books-sync-warehouse', params);
}

export const booksService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  getType,
  exportData,
  importBooks,
  syncBooks,
};
